export type ImageConfig = {
  imageName: string;
  position: number;
};

// PT-7995: Configuration for mood/USP
export type ImagesConfig = {
  [key: string]: ImageConfig[];
};

export const IMAGES_CONFIG: ImagesConfig = {
  '/products/nassfutter-geniesser-filets-ente-und-spargel-fur-katzen': [
    { imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Ente-02.jpg', position: 3 },
    { imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-01.jpg', position: 4 },
  ],
  '/products/nassfutter-juicy-filets-huhnerfilet-fur-katzen': [
    { imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Huhn-02.jpg', position: 3 },
    { imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-01.jpg', position: 4 },
  ],
  '/products/nassfutter-juicy-filets-lachsfilet-fur-katzen': [
    { imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Lachs-02.jpg', position: 3 },
  ],
  '/products/juicy-filets-huhn-mit-lammleber-und-karotte-fur-katzen': [
    { imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Lamm-02.jpg', position: 3 },
    { imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-01.jpg', position: 4 },
  ],
  '/products/juicy-filets-thunfisch-fur-katzen': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Thunfisch-02.jpg',
      position: 3,
    },
  ],
  '/products/juicy-filets-multipack-huhn-mit-ei-ente-huhn-mit-lammleber-fur-katzen':
    [
      {
        imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-01.jpg',
        position: 5,
      },
    ],
  '/products/nassfutter-senior-huhn-mit-kartoffel-ricotta-birne-fur-hunde': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Senior-Huhn-02.jpg',
      position: 3,
    },
  ],
  '/products/nassfutter-senior-rind-mit-zucchini-kurbis-apfel-fur-hunde': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Senior-Rind-02.jpg',
      position: 3,
    },
  ],
  '/products/nassfutter-pferd-mit-susskartoffel-und-distelol-fur-hunde': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Hypo-Pferd-02.jpg',
      position: 4,
    },
  ],
  '/products/nassfutter-sensitiv-ziege-mit-pastinake-und-distelol-fur-hunde': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Hypo-Ziege-02.jpg',
      position: 4,
    },
  ],
  '/products/nassfutter-kanguru-mit-kurbis-quinoa-und-kamille-fur-hunde': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Hypo-Kaenguru-02.jpg',
      position: 4,
    },
  ],
  '/products/trockenfutter-soft-huhn-mit-kurbis-preiselbeere-fur-hunde': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-TroFu-Soft-Huhn-02.jpg',
      position: 5,
    },
    {
      imageName: 'pd-MKT-ABC-PDP-Test-TroFu-Soft-Huhn-01.jpg',
      position: 6,
    },
  ],
  '/products/trockenfutter-soft-rind-mit-brokkoli-granatapfel-fur-hunde': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-TroFu-Soft-Rind-02.jpg',
      position: 5,
    },
    {
      imageName: 'pd-MKT-ABC-PDP-Test-TroFu-Soft-Rind-01.jpg',
      position: 6,
    },
  ],
  '/products/nassfutter-saucen-menu-huhnerfilet-und-zucchini-fur-katzen': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Huhn-02.jpg',
      position: 3,
    },
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Huhn-01.jpg',
      position: 4,
    },
  ],
  '/products/nassfutter-saucen-menu-lachsfilet-und-rote-beete-fur-katzen': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Lachs-01.jpg',
      position: 3,
    },
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Lachs-02.jpg',
      position: 4,
    },
  ],
  '/products/nassfutter-saucen-menu-putenfilet-mit-karotte-fur-katzen': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Pute-02.jpg',
      position: 3,
    },
  ],
  '/products/nassfutter-saucen-menu-rind-und-kurbis-fur-katzen': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Rind-02.jpg',
      position: 3,
    },
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Rind-01.jpg',
      position: 4,
    },
  ],
  '/products/nassfutter-saucen-menu-thunfischfilet-fur-katzen': [
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Thunfisch-02.jpg',
      position: 3,
    },
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Thunfisch-01.jpg',
      position: 4,
    },
  ],
};
